
  const __registry__ = require('../../../spiferack/client/index.js')
  'use strict';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.object.get-prototype-of.js");
require("core-js/modules/es.object.set-prototype-of.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var Form = require('@npm/spiferack/form');
var PropTypes = require('prop-types');
var types = require('../../types');
var React = require('react');
var _require = require('react-helmet'),
  Helmet = _require.Helmet;
var GeneralSupportForm = require('../../components/contact/general-support-form.js');
var SecurityForm = require('../../components/contact/security-form');
var AccountForm = require('../../components/contact/account-form');
var LoginPrompt = require('../../components/contact/login-prompt');
var styles = require('../../components/contact/contact.css');
var Select = require('../../components/inputs/select');
var Sidebar = require('./sidebar');
var _require2 = require('../../utils/aria-live'),
  announce = _require2.announce;
var ContactPage = /*#__PURE__*/function (_React$PureComponent) {
  function ContactPage() {
    _classCallCheck(this, ContactPage);
    return _callSuper(this, ContactPage, arguments);
  }
  _inherits(ContactPage, _React$PureComponent);
  return _createClass(ContactPage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      announce('npm support');
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        showContactForm = _this$props.showContactForm,
        user = _this$props.user;
      return /*#__PURE__*/React.createElement("div", {
        className: styles.contact
      }, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("title", null, "npm | Support")), /*#__PURE__*/React.createElement("div", {
        className: "w-70-ns pr4-ns ph2"
      }, user || showContactForm ? /*#__PURE__*/React.createElement(ContactForm, this.props) : /*#__PURE__*/React.createElement(LoginPrompt, this.props)), /*#__PURE__*/React.createElement("div", {
        className: "w-30-ns ph2"
      }, /*#__PURE__*/React.createElement(Sidebar, null)));
    }
  }]);
}(React.PureComponent);
ContactPage.propTypes = {
  user: PropTypes.object,
  showContactForm: PropTypes.bool,
  formData: types.formData,
  showCaptcha: PropTypes.bool
};
var ContactForm = /*#__PURE__*/function (_React$Component) {
  function ContactForm(props) {
    var _this;
    _classCallCheck(this, ContactForm);
    _this = _callSuper(this, ContactForm, [props]);
    _this.onSubmit = _this.onSubmit.bind(_this);
    return _this;
  }
  _inherits(ContactForm, _React$Component);
  return _createClass(ContactForm, [{
    key: "isFormDataSelected",
    value: function isFormDataSelected(name) {
      if (this.props.formData && this.props.formData.contact && this.props.formData.contact.inquire) {
        return this.props.formData.contact.inquire.value === name;
      }
      return false;
    }
  }, {
    key: "shouldShowGeneralForm",
    value: function shouldShowGeneralForm(props) {
      var formData = props.formData;
      if (!formData) return false;
      if (!formData.contact) return false;
      if (!formData.contact.inquire) return false;
      if (formData.contact.inquire.value === 'none-selected') return false;
      var generalSupportFormFields = ['support'];
      return generalSupportFormFields.includes(formData.contact.inquire.value);
    }
  }, {
    key: "onSubmit",
    value: function onSubmit(ev) {
      window.scrollTo(0, 0);
      Form.submit(ev);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        formData = _this$props2.formData,
        disableUsernameField = _this$props2.disableUsernameField,
        showCaptcha = _this$props2.showCaptcha;
      var values = [{
        value: 'none-selected',
        label: 'Choose one of the following'
      }, {
        value: 'support',
        label: 'There is a problem with the npm registry'
      }, {
        value: 'account',
        label: 'I have an account or billing issue'
      }, {
        value: 'naming-dispute',
        label: 'I have a naming dispute for a user, org, or package'
      }, {
        value: 'security',
        label: "I'm reporting spam, abuse or a security issue"
      }];
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h1", {
        className: styles.mainHeader
      }, "Contact Us"), /*#__PURE__*/React.createElement("p", {
        className: styles.description
      }, "Get help with the npm registry or your npm account."), /*#__PURE__*/React.createElement("p", {
        className: styles.description
      }, "Please contact us if you need help with the npm registry or with your npm account, if you are reporting security concerns in an npm product, or if you need to report malicious or abusive behavior in a package in the registry."), /*#__PURE__*/React.createElement(Select, {
        label: "How can we help?",
        formId: "contact",
        name: "inquire",
        formData: formData,
        value: values[0].value,
        className: "category",
        values: values
      }), this.shouldShowGeneralForm(this.props) && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(GeneralSupportForm, {
        onSubmit: this.onSubmit,
        disableUsernameField: disableUsernameField,
        formData: formData,
        showCaptcha: showCaptcha
      })), this.isFormDataSelected('naming-dispute') && /*#__PURE__*/React.createElement("p", {
        className: styles.description
      }, "Please submit any naming disputes for packages, org, or usernames to", ' ', /*#__PURE__*/React.createElement("a", {
        href: "https://support.github.com/contact/npm-name-disputes"
      }, "https://support.github.com/contact/npm-name-disputes"), "."), this.isFormDataSelected('security') && /*#__PURE__*/React.createElement(SecurityForm, {
        disableUsernameField: disableUsernameField,
        onSubmit: this.onSubmit,
        formData: formData,
        showCaptcha: showCaptcha
      }), this.isFormDataSelected('account') && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(AccountForm, {
        disableUsernameField: disableUsernameField,
        onSubmit: this.onSubmit,
        formData: formData,
        showCaptcha: showCaptcha
      })));
    }
  }]);
}(React.Component);
ContactForm.propTypes = {
  disableUsernameField: PropTypes.bool,
  showCaptcha: PropTypes.bool,
  formData: types.formData
};
module.exports = ContactPage;
  let __hot__
  
  __registry__.register('contact/contact', module.exports, __hot__)
  